import { render, staticRenderFns } from "./addReformPrototype.vue?vue&type=template&id=707e668a"
import script from "./addReformPrototype.vue?vue&type=script&lang=js"
export * from "./addReformPrototype.vue?vue&type=script&lang=js"
import style0 from "./addReformPrototype.vue?vue&type=style&index=0&id=707e668a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports